import React from 'react';
import './Css/Header.css'; 
import { Container, Row, Col } from 'react-bootstrap';

const Header = () => {
  return (
    <section className="cv-header">
      <Container className="text-center">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <div className="header-container">
            <h1 className="rotate-animation">Rudy Rolland</h1>
            <div className="header-container-1">
              <p className="fade-in">Développeur Web Full Stack</p>
              <p className="fade-in titre-pros">Formation complétée en Cybersécurité</p>
              <p className="fade-in">Montpellier</p>
            </div>
            </div>
          
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Header;
